import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from './Button'
import T from './T'
import { appTypeConfig } from '../../common/config'
import { fetchMyOrderCourierLink } from '../../common/app/actions'

export default function OrderCourierButton() {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const { isOrderCourierLoginEnabled } = appTypeConfig
  if (!isOrderCourierLoginEnabled) return null

  const handleClick = async () => {
    setIsLoading(true)
    const response = await dispatch(fetchMyOrderCourierLink()).meta.action
      .payload

    if (response.code === 200) {
      const { link } = response.data
      window.open(link, '_blank')
    }
    setIsLoading(false)
  }

  return (
    <Button large onClick={handleClick} disabled={isLoading}>
      <T>Order courier</T>
    </Button>
  )
}
